<style scoped>
.property-list {
	display: flex;
	flex-direction: column;
}

.property-row {
	display: grid;
	grid-template-columns: 10rem 1fr;
	gap: 0.5rem;
	padding: 0.25rem 0.5rem;
	border-radius: 4px;
	align-items: baseline;
}

.property-row.anomalous {
	background: #fff3cd;
	border: 1px solid #ffc107;
}

.property-row .property-label {
	color: #666;
}

.property-row .property-value {
	font-weight: 500;
}

.property-row.anomalous .property-value {
	font-weight: 700;
	color: #7a5b00;
}

.anomaly-mark {
	color: #b45309;
	margin-right: 0.25rem;
}

.peer-context {
	font-weight: 400;
	color: #7a5b00;
	margin-left: 0.5rem;
}

.derived-mark,
.attribution {
	font-weight: 400;
	color: #999;
	margin-left: 0.5rem;
}
</style>

<template>
	<div class="property-list">
		<div
			v-for="entry in entries"
			:key="entry.key"
			class="property-row"
			:class="{ anomalous: entry.anomalous }"
		>
			<span class="property-label">{{ entry.label }}</span>
			<span class="property-value">
				<span v-if="entry.anomalous" class="anomaly-mark">⚠</span>
				{{ entry.value
				}}<template v-if="entry.unit"> {{ entry.unit }}</template>
				<span
					v-if="entry.derived"
					class="derived-mark"
					title="Derived from the extracted values"
				>
					(derived)
				</span>
				<span v-if="entry.anomalous && entry.peerContext" class="peer-context">
					({{ entry.peerContext }})
				</span>
				<span v-if="entry.attribution" class="attribution">
					· {{ entry.attribution }}
				</span>
			</span>
		</div>
	</div>
</template>

<script setup lang="ts">
import { TranscriptPropertyEntry } from "@/type/api";

interface Props {
	entries: TranscriptPropertyEntry[];
}
defineProps<Props>();
</script>
